export default class CustomModal{

    constructor(){
        this.init();
    }

    template(content, title, isApple){

        const titleContainer = title === "no-title" ? "" : `<div class="modal-title">${title}</div>`
        
        const classContainer = (isApple != undefined && isApple === "true") ? "apple" : ""

        return `
            <div id="modal" class="modal">
                <div class="modal-container animated slideInUp ${classContainer}">
                    <div id="modal-close" class="modal-close">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15.1 2.3L13.7.9 8 6.6 2.3.9.9 2.3 6.6 8 .9 13.7l1.4 1.4L8 9.4l5.7 5.7 1.4-1.4L9.4 8"></path></svg>
                    </div>
                    ${titleContainer}
                    <div class="modal-content">
                        ${content}
                    </div>
                </div>
            </div>
        `;        
    }

    blockOverflow(action){
        if(action === 'open'){
            document.querySelector('body').style.overflow = 'hidden';
        }else if(action === 'close'){
            document.querySelector('body').style.overflow = 'auto';
        }
    }

    attachCloseEvent(){
        document.getElementById('modal-close').addEventListener("click", (e) => {
          this.close();
        });

        for (const trigger of document.querySelectorAll('.modal-close-btn')) {
            trigger.addEventListener("click", (e) => {
                e.preventDefault();

                this.close();
            });
        }
    }

    show(link){
        const node = document.createElement("div");
        node.innerHTML = this.template(link.innerHTML, link.dataset.modalTitle, link.dataset.modalApple)
        document.body.appendChild(node);
        this.blockOverflow('open');
        this.attachCloseEvent();
    }

    close(){
        document.getElementById('modal').remove();
        this.blockOverflow('close');
    }

    attachEvents(){
      const elms = document.querySelectorAll('[data-modal]');
      for (const elm of elms) {
        elm.addEventListener("click", (e) => {
            document.getElementById(e.target.dataset.modal)
            const link = document.querySelector(`[data-link=${e.target.dataset.modal}]`);
            if(link) this.show(link);
        });
      }
    }

    init(){
        this.attachEvents();
    }

}
window.addEventListener('load', async () => {
    new CustomModal();
});